import { render } from "./BranchSelector.vue?vue&type=template&id=f845dcfe&scoped=true"
import script from "./BranchSelector.vue?vue&type=script&lang=js"
export * from "./BranchSelector.vue?vue&type=script&lang=js"

import "./BranchSelector.vue?vue&type=style&index=0&id=f845dcfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f845dcfe"]])

export default __exports__